// AUTO-GENERATED by scripts/gen-content-meta.ts — do not edit by hand.
import type { ServicePillar } from "./types";

export type CoreServicePillar = Pick<
  ServicePillar,
  "slug" | "category" | "h1" | "metaTitle" | "metaDesc" | "heroSubtitle" | "pricing" | "faqs"
> & { pricing: NonNullable<ServicePillar["pricing"]> };

export const CORE_SERVICE_PILLARS: Record<string, CoreServicePillar> = {
  "notary-public": {
    "slug": "notary-public",
    "category": "notary",
    "h1": "Notary Public ภูเก็ต — รับรองเอกสารโดยทนายความสำหรับลูกค้าชาวไทย",
    "metaTitle": "Notary Public ภูเก็ต (ลูกค้าไทย) | Thai Notary Phuket",
    "metaDesc": "Notary Public ภูเก็ตโดยทนายผู้ทำคำรับรองลายมือชื่อและเอกสาร รับรองลายมือชื่อ สำเนาถูกต้อง คำแปล POA Affidavit พร้อม MFA และสถานทูต บริการ on-site ทั่วเกาะ",
    "heroSubtitle": "บริการรับรองเอกสารโดยทนายความผู้ทำคำรับรองลายมือชื่อและเอกสาร (Notarial Services Attorney) ที่ขึ้นทะเบียนกับสภาทนายความแห่งประเทศไทย — ครอบคลุมงานทุกประเภทเอกสารที่ใช้ในไทยและต่างประเทศ มีจุดบริการในเขตเมืองภูเก็ต ป่าตอง เชิงทะเล และนัด on-site ถึงสำนักงาน/คอนโด/วิลล่าทั่วเกาะ",
    "pricing": [
      {
        "item": "Notary รับรองลายมือชื่อ",
        "price": "1,500 บาท / เอกสาร",
        "note": "ราคามาตรฐาน ไม่จำกัดหน้า"
      },
      {
        "item": "Notary รับรองสำเนาถูกต้อง (True Copy)",
        "price": "1,500 บาท / ชุด",
        "note": "1 ชุด = ไม่เกิน 10 หน้า"
      },
      {
        "item": "Notary รับรองคำแปล (Certified Translation)",
        "price": "2,000 บาท / เอกสาร",
        "note": "ไม่รวมค่าแปล"
      },
      {
        "item": "Affidavit / Statutory Declaration",
        "price": "3,000–5,000 บาท",
        "note": "ขึ้นกับความซับซ้อนของ wording"
      },
      {
        "item": "Power of Attorney (POA)",
        "price": "3,500–6,000 บาท",
        "note": "ร่างเองหรือมีตัวอย่าง"
      },
      {
        "item": "เอกสารธุรกิจ (Company Affidavit, Minutes, Resolution)",
        "price": "4,000–8,000 บาท",
        "note": "ต่อชุด"
      }
    ],
    "faqs": [
      {
        "q": "Notary Public ของไทยกับ Notary Public ที่อเมริกา/ยุโรป ต่างกันอย่างไร?",
        "a": "ในประเทศไทยไม่มีตำแหน่ง Notary Public แยกจากทนาย — กฎหมายไทยให้ทนายความที่ขึ้นทะเบียนพิเศษกับสภาทนายความ ทำหน้าที่เป็น Notarial Services Attorney เทียบเท่ากับ Notary Public ในต่างประเทศ คำรับรองของเราเป็นที่ยอมรับในทุกประเทศที่รับเอกสารจากประเทศไทย โดยมักต้องผ่าน MFA และสถานทูตต่อ"
      },
      {
        "q": "ลูกค้าไม่อยู่ในภูเก็ต ทำ Notary ออนไลน์ได้ไหม?",
        "a": "ปัจจุบันกฎหมายไทยยังไม่อนุญาตให้ทำ Notary ทางวิดีโอคอลแบบ Remote Online Notarization (RON) ลูกค้าต้องอยู่ต่อหน้าทนายในวันเซ็นเสมอ แต่ทีมเราเดินทาง on-site ทั่วเกาะภูเก็ตและจังหวัดใกล้เคียงได้ และมีสาขาในกรุงเทพหากลูกค้าสะดวกเข้ามาในเมืองหลวง"
      },
      {
        "q": "ต้องเตรียมเอกสารอะไรไปวันเซ็น?",
        "a": "เตรียม (1) บัตรประจำตัวประชาชนตัวจริง + พาสปอร์ตตัวจริง (ถ้ามี) (2) เอกสารที่ต้องการ Notary ฉบับจริง + สำเนา (3) ในกรณีบริษัท เพิ่มหนังสือรับรองอายุไม่เกิน 6 เดือน + ตราบริษัท + บัตรกรรมการผู้มีอำนาจลงนาม"
      }
    ]
  },
  "notary-public-english": {
    "slug": "notary-public-english",
    "category": "notary",
    "h1": "Notary Public Phuket (English-Speaking) — Notarial Services Attorney for Expats & Foreign Nationals",
    "metaTitle": "Notary Public Phuket English | Thai Notary",
    "metaDesc": "English-speaking Notary Public in Phuket — affidavits, POAs, certified copies, signature authentication and embassy legalization. On-site island-wide, same-day.",
    "heroSubtitle": "A fully English-speaking Notarial Services Attorney team based in Phuket, serving expats, digital nomads, property owners, retirees and international companies across Patong, Cherngtalay, Rawai, Chalong, Kata and every marina on the island — with same-day appointments and door-to-door on-site service.",
    "pricing": [
      {
        "item": "Signature notarisation",
        "price": "THB 1,500",
        "note": "Per signature, English certification"
      },
      {
        "item": "Certified True Copy",
        "price": "THB 1,500",
        "note": "Per set, up to 10 pages"
      },
      {
        "item": "Certified True Translation",
        "price": "THB 2,000",
        "note": "Per document, translation fee separate"
      },
      {
        "item": "Affidavit / Statutory Declaration",
        "price": "THB 3,000 – 5,000",
        "note": "Depending on wording complexity"
      },
      {
        "item": "Power of Attorney (POA)",
        "price": "THB 3,500 – 6,000",
        "note": "Custom drafting available"
      },
      {
        "item": "Corporate notarisation bundle",
        "price": "THB 4,000 – 8,000",
        "note": "Affidavit + Minutes + Resolution"
      }
    ],
    "faqs": [
      {
        "q": "Is a Thai Notarial Services Attorney recognised abroad?",
        "a": "Yes. Every country that maintains diplomatic relations with Thailand accepts certifications issued by a Notarial Services Attorney, usually after the document is also legalised by Thailand’s MFA Consular Department and the destination country’s embassy in Bangkok. From 2026 onwards, Apostille-member countries accept the certification with only an Apostille from MFA — no embassy step needed."
      },
      {
        "q": "Can I notarise a document over Zoom or video call?",
        "a": "No. Thai law does not currently permit Remote Online Notarization (RON). You must be physically present in front of the attorney at the moment of signing. To make this convenient, we offer on-site service anywhere on Phuket — your villa, condo, hotel, office, marina or hospital bedside."
      },
      {
        "q": "What ID do I need to bring?",
        "a": "An original valid passport is mandatory for all foreign clients. We also recommend bringing a second photo ID such as a driver licence, plus the original document to be notarised. For corporate signings, also bring a current (≤ 6 months old) DBD company certificate and the corporate seal."
      }
    ]
  },
  "translation-certified-all": {
    "slug": "translation-certified-all",
    "category": "translation",
    "h1": "Certified Translation Phuket — รับรองคำแปลทุกประเทศ ทุกหน่วยงานปลายทาง",
    "metaTitle": "Certified Translation ภูเก็ต ทุกประเทศ | Thai Notary",
    "metaDesc": "Certified Translation ภูเก็ต รองรับมาตรฐาน Notary, MFA, Apostille, Sworn Translator, NAATI, ATA สำหรับทุกประเทศ ทุกหน่วยงาน — ตรง Spec ใช้ได้ทันที",
    "heroSubtitle": "ในโลกของเอกสารระหว่างประเทศ ‘การแปล’ และ ‘การรับรอง’ คือคนละขั้นตอน เราเชี่ยวชาญทั้งสองเรื่องและรู้ว่ามาตรฐานใดเหมาะกับปลายทางใด — Notary ไทย, MFA, Apostille (Hague 2026+), Sworn Translator EU, NAATI ออสเตรเลีย, ATA สหรัฐ, MoJ ไทย",
    "pricing": [
      {
        "item": "Certified Translation มาตรฐานพื้นฐาน",
        "price": "500–1,200 บาท / หน้า",
        "note": "ไทย ↔ อังกฤษ"
      },
      {
        "item": "Certified + Notary",
        "price": "+1,500 บาท / เอกสาร",
        "note": "สำหรับ UK/USA Immigration"
      },
      {
        "item": "NAATI",
        "price": "1,300–2,500 บาท / เอกสาร",
        "note": "สำหรับออสเตรเลีย"
      },
      {
        "item": "Sworn Translator EU",
        "price": "1,200–2,500 บาท / หน้า",
        "note": "ตามประเทศ"
      },
      {
        "item": "ATA Statement (US)",
        "price": "+800 บาท / เอกสาร",
        "note": ""
      },
      {
        "item": "Notary + MFA + Embassy Bundle",
        "price": "8,000–25,000 บาท",
        "note": "ครอบคลุมทุกประเทศที่ไม่ใช่ Apostille"
      }
    ],
    "faqs": [
      {
        "q": "ต่างจาก ‘แปลธรรมดา + ประทับตรา’ อย่างไร?",
        "a": "Certified Translation ที่แท้จริงต้องมี Statement of Accuracy ลายเซ็นจริง วันที่ ตราประทับและเลขทะเบียนของผู้รับรอง ครบทุกหน้า — และต้องเลือกมาตรฐานที่ตรงกับหน่วยงานปลายทาง"
      },
      {
        "q": "ใช้ Apostille ได้หรือยังในประเทศไทย?",
        "a": "ไทยเข้าร่วมอนุสัญญา Hague Apostille ตั้งแต่ปี 2026 — ตั้งแต่วันที่มีผลบังคับใช้ สามารถใช้ Apostille แทน Embassy Legalization ได้กับกว่า 120 ประเทศ ลดเวลาและค่าใช้จ่ายอย่างมาก"
      },
      {
        "q": "เลือกมาตรฐานผิดจะเกิดอะไร?",
        "a": "ปลายทางมักปฏิเสธทันทีและสั่งให้เริ่มกระบวนการใหม่ — ลูกค้าเสียทั้งเวลาและค่าธรรมเนียมรอบใหม่ ทีมเรามีหน้าที่ป้องกันสิ่งนี้ด้วยการตรวจ Matrix ทุกครั้งก่อนเริ่มงาน"
      }
    ]
  },
  "mfa-consular": {
    "slug": "mfa-consular",
    "category": "legalization",
    "h1": "รับรองเอกสาร กรมการกงสุล (MFA) ในภูเก็ต — บริการครบวงจร ไม่ต้องเดินทางไปกรุงเทพฯ",
    "metaTitle": "รับรองเอกสารกงสุล (MFA) ในภูเก็ต | บริการแปลและรับรองครบวงจร",
    "metaDesc": "บริการรับรองเอกสาร กรมการกงสุล (MFA) สำหรับชาวภูเก็ตและต่างชาติ ครบวงจรตั้งแต่แปลเอกสาร นำส่งกงสุล จนถึงรับรองสถานทูต สะดวก รวดเร็ว ไม่ต้องเดินทางไปกรุงเทพฯ",
    "heroSubtitle": "บริการรับรองเอกสารโดยกระทรวงการต่างประเทศ (MFA) พร้อมบริการแปลและยื่นเรื่องแทนแบบครบวงจร สำหรับผู้ที่พำนักในภูเก็ต",
    "pricing": [
      {
        "item": "ค่าบริการแปล (ไทย-อังกฤษ)",
        "price": "500 - 1,200.-",
        "note": "ต่อหน้า (ยังไม่รวมค่ารับรอง)"
      },
      {
        "item": "ค่าธรรมเนียมกงสุล",
        "price": "200 - 800.-",
        "note": "ต่อชุด (จ่ายตามใบเสร็จจริง — ปกติ/ด่วน)"
      },
      {
        "item": "ค่าบริการนำเอกสารไปรับรองกงสุล",
        "price": "2,500 - 5,000.-",
        "note": "ต่อ 1 ท่าน รวม Messenger ภูเก็ต-กรุงเทพฯ"
      },
      {
        "item": "ค่าจัดส่งเอกสารในประเทศ",
        "price": "100.-",
        "note": "Kerry / EMS ทั่วไทย"
      },
      {
        "item": "ค่าจัดส่งเอกสารทั่วโลก",
        "price": "2,500.-",
        "note": "DHL Express"
      }
    ],
    "faqs": [
      {
        "q": "นิติกรณ์ของกรมการกงสุลรับรองอะไรกันแน่?",
        "a": "รับรองว่าตราประทับและลายมือชื่อของเจ้าหน้าที่ผู้ออกเอกสารหรือผู้แปลตรงกับตัวอย่างที่มีอยู่ในระบบ ไม่ได้รับรองความถูกต้องของเนื้อความคำแปล ความรับผิดชอบต่อเนื้อความยังอยู่ที่ผู้แปล ตรวจระเบียบล่าสุดได้ที่ consular.mfa.go.th"
      },
      {
        "q": "หลังนิติกรณ์แล้ว ต้อง Apostille หรือเข้าสถานทูต?",
        "a": "เลือกเพียงสายเดียวตามประเทศปลายทาง ถ้าปลายทางเป็นภาคีอนุสัญญา Hague 1961 ให้จบที่ Apostille ถ้าไม่ใช่ภาคีต้องนำไปรับรองที่สถานทูตของประเทศนั้นในกรุงเทพฯ ตรวจสถานะภาคีได้ที่ hcch.net ก่อนเริ่มงาน"
      },
      {
        "q": "ไทยไม่มี sworn translator แล้วปลายทางจะยอมรับคำแปลไหม?",
        "a": "ประเทศไทยไม่มีระบบผู้แปลสาบานตนตามกฎหมาย จึงใช้คำว่า 'นักแปลที่กรมการกงสุลรับรองลายมือชื่อ' บางประเทศ เช่น เยอรมนี ฝรั่งเศส สเปน อิตาลี อาจกำหนดให้คำแปลทำโดยผู้แปลขึ้นทะเบียนในประเทศตน กรณีนี้เราจัดสายแปลปลายทางเพิ่มให้ได้"
      }
    ]
  },
  "embassy-legalization": {
    "slug": "embassy-legalization",
    "category": "legalization",
    "h1": "รับรองสถานทูต (Embassy Legalization) ในภูเก็ต — ครบทุกประเทศทั่วโลก",
    "metaTitle": "รับรองสถานทูตในภูเก็ต | บริการแปลและรับรองครบวงจร",
    "metaDesc": "บริการรับรองเอกสารที่สถานทูตต่างๆ ในกรุงเทพฯ สำหรับผู้พำนักในภูเก็ต ครอบคลุมยุโรป อเมริกา ออสเตรเลีย จีน และตะวันออกกลาง พร้อมบริการแปลและยื่นเรื่องแทน",
    "heroSubtitle": "จัดการทุกขั้นตอนการรับรองเอกสารที่สถานทูต (Legalization/Authentication) เพื่อให้เอกสารของท่านใช้ได้อย่างสมบูรณ์ในต่างประเทศ",
    "pricing": [
      {
        "item": "ค่าบริการยื่นสถานทูต (Service Fee)",
        "price": "5,000 - 12,000.-",
        "note": "ต่อสถานทูต (ไม่รวมค่าธรรมเนียมรัฐ)"
      },
      {
        "item": "ค่าธรรมเนียมสถานทูต",
        "price": "1,800 - 2,600.-",
        "note": "ต่อชุด (อ้างอิงใบเสร็จสถานทูตแต่ละแห่ง)"
      },
      {
        "item": "ค่าบริการแปล (โดยนักแปลสถานทูต)",
        "price": "800 - 2,500.-",
        "note": "ภาษาเยอรมัน/ฝรั่งเศส/สเปน ฯลฯ ยังไม่รวมรับรอง"
      },
      {
        "item": "บริการแปลมาตรฐาน (ไทย-อังกฤษ)",
        "price": "500 - 1,200.-",
        "note": "ยังไม่รวมค่ารับรอง"
      },
      {
        "item": "ค่าจัดส่งในประเทศ / ทั่วโลก",
        "price": "100 / 2,500.-",
        "note": "Kerry-EMS / DHL Express"
      }
    ],
    "faqs": [
      {
        "q": "รู้ได้อย่างไรว่าต้องเข้าสถานทูตหรือใช้ Apostille?",
        "a": "ดูที่สถานะภาคีอนุสัญญา Hague 1961 ของประเทศปลายทาง ถ้าเป็นภาคีให้จบที่ Apostille ของกรมการกงสุล ถ้าไม่ใช่ภาคีต้องรับรองที่สถานทูตของประเทศนั้นในกรุงเทพฯ ตรวจรายชื่อภาคีล่าสุดที่ hcch.net เพราะมีประเทศเข้าใหม่เป็นระยะ"
      },
      {
        "q": "สถานทูตรับรองความถูกต้องของคำแปลด้วยไหม?",
        "a": "โดยหลักไม่ สถานทูตรับรองตราและลายมือชื่อของเจ้าหน้าที่กระทรวงการต่างประเทศไทยเท่านั้น บางสถานทูตมีรายชื่อผู้แปลที่ตนยอมรับและจะปฏิเสธคำแปลจากผู้แปลนอกรายชื่อ เราจึงตรวจข้อกำหนดรายสถานทูตก่อนแปลทุกครั้ง"
      },
      {
        "q": "ต้องไปแสดงตนที่สถานทูตเองไหม?",
        "a": "ส่วนใหญ่ไม่ต้อง ยื่นแทนได้ด้วยหนังสือมอบอำนาจและสำเนาพาสปอร์ต ยกเว้นบางสถานทูตที่กำหนดให้เจ้าของเอกสารมาลงนามต่อหน้าเจ้าหน้าที่ เช่น กรณีหนังสือมอบอำนาจหรือหนังสือยินยอมบางประเภท"
      }
    ]
  },
  "police-clearance": {
    "slug": "police-clearance",
    "category": "background",
    "h1": "ขอใบรับรองความประพฤติ (Police Clearance Certificate) ในภูเก็ต — บริการยื่นแทน 100%",
    "metaTitle": "ขอใบรับรองความประพฤติภูเก็ต | บริการตรวจสอบประวัติอาชญากรรม",
    "metaDesc": "ขอใบรับรองความประพฤติ Police Clearance จากสำนักงานตำรวจแห่งชาติสำหรับชาวภูเก็ตที่ไปทำงาน เรียน หรือแต่งงานต่างประเทศ สะดวก รวดเร็ว ไม่ต้องเดินทางไปกรุงเทพ",
    "heroSubtitle": "บริการขอหนังสือรับรองความประพฤติจากศูนย์บริการออกหนังสือรับรองความประพฤติ สำนักงานตำรวจแห่งชาติ แบบครบวงจร",
    "pricing": [
      {
        "item": "ขอใบตรวจประวัติใช้ในไทย",
        "price": "2,000.-",
        "note": "ต่อ 1 ท่าน (พนักงาน/ตรวจตัวเอง)"
      },
      {
        "item": "ขอใบตรวจประวัติเพื่อใช้ต่างประเทศ",
        "price": "4,000 - 8,000.-",
        "note": "ยังไม่รวมค่าแปล + กงสุล + สถานทูต"
      },
      {
        "item": "บริการแปลเป็นภาษาอังกฤษ",
        "price": "500 - 1,200.-",
        "note": "ต่อหน้า ยังไม่รวมค่ารับรอง"
      },
      {
        "item": "บริการรับรองกงสุล (MFA) ต่อ",
        "price": "2,500 - 5,000.-",
        "note": "ต่อท่าน + ค่าธรรมเนียม 200–800 บาท/ชุด"
      },
      {
        "item": "บริการด่วนพิเศษ (Express)",
        "price": "สอบถามเพิ่มเติม",
        "note": "ขึ้นอยู่กับความเร่งด่วนของเคส"
      }
    ],
    "faqs": [
      {
        "q": "ถ้าเคยมีคดีความแต่จบไปแล้ว จะขอได้ไหม?",
        "a": "ขอได้ครับ แต่ในใบรับรองจะระบุประวัติเหล่านั้นไว้ ท่านอาจต้องขอคำสั่งศาลฉบับถึงที่สุดประกอบการยื่น Visa ซึ่งเรามีทีมทนายช่วยประสานงานให้ได้"
      },
      {
        "q": "ต้องไปพิมพ์ลายนิ้วมือที่กรุงเทพฯ ไหม?",
        "a": "ไม่ต้องครับ ท่านสามารถพิมพ์ลายนิ้วมือที่สถานีตำรวจในภูเก็ตได้เลย แล้วส่งเอกสารมาให้เรายื่นแทน"
      },
      {
        "q": "ชาวต่างชาติที่อยู่ป่าตองต้องการขอเพื่อไปทำงานออสเตรเลีย ทำได้ไหม?",
        "a": "ได้ครับ เราจัดการเคสชาวต่างชาติที่อยู่ในภูเก็ตเพื่อส่งไปประเทศที่สามเป็นประจำ"
      }
    ]
  },
  "police-clearance-intl": {
    "slug": "police-clearance-intl",
    "category": "background",
    "h1": "Thai Police Clearance for Expats in Phuket — International Background Checks",
    "metaTitle": "Thai Police Clearance for Expats Phuket | Background Check",
    "metaDesc": "Thai Police Clearance Certificate for Phuket expats — fingerprinting, Bangkok submission and secure delivery. No travel required, ready for visa or migration.",
    "heroSubtitle": "Applying for a visa to another country? We assist Phuket expats in obtaining the mandatory Thai Police Clearance Certificate efficiently.",
    "pricing": [
      {
        "item": "Police Clearance for Overseas Use",
        "price": "4,000 - 8,000 THB",
        "note": "Per applicant — excludes translation, MFA, and embassy fees"
      },
      {
        "item": "Certified Translation (Thai-English)",
        "price": "500 - 1,200 THB",
        "note": "Per page; other languages 800 – 2,500 THB"
      },
      {
        "item": "MFA Legalization Add-on",
        "price": "2,500 - 5,000 THB",
        "note": "Per person + 200 – 800 THB govt fee per set"
      },
      {
        "item": "Embassy Legalization Add-on",
        "price": "5,000 - 12,000 THB",
        "note": "Per embassy + 1,800 – 2,600 THB govt fee per set"
      },
      {
        "item": "Domestic / Worldwide Shipping",
        "price": "100 / 2,500 THB",
        "note": "Kerry-EMS / DHL Express"
      }
    ],
    "faqs": [
      {
        "q": "Do I have to go to Bangkok myself?",
        "a": "No. We handle the submission and collection in Bangkok on your behalf. You only need to provide fingerprints in Phuket."
      },
      {
        "q": "I am currently outside Thailand; can you help?",
        "a": "Yes. You can provide fingerprints at a Thai Embassy or a police station in your current country and mail them to us in Phuket. We handle the rest."
      },
      {
        "q": "What if I have a previous overstay?",
        "a": "A minor overstay usually doesn't prevent you from getting a PCC, but it must be properly documented. We can advise on more complex cases."
      }
    ]
  },
  "work-permit": {
    "slug": "work-permit",
    "category": "visa-marriage",
    "h1": "Thailand Visa & Work Permit for Foreigners in Phuket",
    "metaTitle": "Work Permit Phuket | Non-B Visa & WP for Foreigners",
    "metaDesc": "บริการขอ Work Permit ใบอนุญาตทำงานสำหรับชาวต่างชาติในภูเก็ต — Non-B Visa, BOI, จดบริษัท, ต่ออายุ, เปลี่ยนนายจ้าง พร้อมรายงาน 90 วัน และ Re-Entry Permit",
    "heroSubtitle": "From Non-B visa to Work Permit issuance, renewal, and 90-day compliance — we handle every step at Phuket Labour Office and Immigration so you can focus on running your business or career.",
    "pricing": [
      {
        "item": "Non-B Visa + Work Permit (first time)",
        "price": "THB 25,000 – 35,000",
        "note": "Standard SME"
      },
      {
        "item": "BOI Smart Visa",
        "price": "THB 35,000 – 60,000"
      },
      {
        "item": "LTR Visa (incl. WP)",
        "price": "THB 45,000 – 80,000"
      },
      {
        "item": "Yearly extension",
        "price": "THB 12,000 – 18,000"
      },
      {
        "item": "90-day report (each)",
        "price": "THB 800 – 1,200"
      },
      {
        "item": "Re-entry permit",
        "price": "THB 1,500"
      }
    ],
    "faqs": [
      {
        "q": "Can I work in Phuket on a Tourist visa?",
        "a": "Absolutely not. You need both a Non-B (or equivalent) and a Work Permit."
      },
      {
        "q": "Can my Thai wife's company sponsor my Work Permit?",
        "a": "Yes, with reduced capital requirement (THB 1M) and 4:1 ratio waiver if married."
      },
      {
        "q": "Is remote work for foreign companies legal on Tourist visa?",
        "a": "Grey area — strictly speaking it requires WP. Safer route is DTV or LTR Work-from-Thailand."
      }
    ]
  },
  "thai-visa": {
    "slug": "thai-visa",
    "category": "visa-marriage",
    "h1": "Thailand Visa Service for Foreigners — Tourist, Education, Retirement, LTR, DTV in Phuket",
    "metaTitle": "Thailand Visa Phuket | Tourist, Retirement, LTR, DTV",
    "metaDesc": "Full Thailand visa service in Phuket — Tourist extension, ED, Retirement, LTR, DTV, Elite. Apply, convert, extend. Bilingual team, all nationalities welcome.",
    "heroSubtitle": "We process every Thailand visa type for foreigners in Phuket — from a 30-day tourist extension to a 10-year LTR. End-to-end paperwork, Immigration appointments, and renewals.",
    "pricing": [
      {
        "item": "Tourist extension (30 days)",
        "price": "THB 3,500",
        "note": "Incl. govt fee THB 1,900"
      },
      {
        "item": "Convert Tourist → Non-O",
        "price": "THB 12,000 – 18,000"
      },
      {
        "item": "ED Visa first time",
        "price": "THB 18,000 – 28,000"
      },
      {
        "item": "Non-O Retirement extension",
        "price": "THB 8,000 – 12,000"
      },
      {
        "item": "LTR Visa (full)",
        "price": "THB 45,000 – 80,000"
      },
      {
        "item": "DTV (full service)",
        "price": "THB 18,000 – 28,000"
      }
    ],
    "faqs": [
      {
        "q": "Can I extend my 60-day Visa Exempt in Phuket?",
        "a": "Yes, by 30 days at Phuket Immigration with TM.7, photos, and THB 1,900 fee. We do this routinely."
      },
      {
        "q": "How long does DTV take in Phuket?",
        "a": "Approved in 2–3 weeks if documents are complete."
      },
      {
        "q": "Can I work remotely on DTV?",
        "a": "Yes for foreign employers or your own foreign clients. Not for Thai companies."
      }
    ]
  }
};

export function getCoreServicePillar(slug: string): CoreServicePillar | undefined {
  return CORE_SERVICE_PILLARS[slug];
}
